<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import moment from 'moment';
import { required, requiredIf } from 'vuelidate/lib/validators';

export default {
	page: {
		title: 'User Profile',
		meta: [
			{
				name: 'User Profile',
			},
		],
	},
	components: {},
	props: ['userId', 'userTypeId', 'userName'],
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			buildings: [],
			locations: [],
			approvers: [],
			autoClose: '',
			attendWorship: '',
			isKnowApplicant: '',
			cooperation: '',
			options: ['Yes', 'No'],
			preservePage: 1,
			pageLimit: 10,
			status: [
				{ value: 'draft', text: 'Draft' },
				{ value: 'active', text: 'Active' },
				{ value: 'client discharged', text: 'Client Discharged' },
				{ value: 'unpaired', text: 'Unpaired' },
				{ value: 'completed', text: 'Completed' },
			],
			currentUserData: JSON.parse(localStorage.getItem('user')),
			tags: null,
			mentorRoles: null,
			totalHours: '',
			mentorRoleForm: {
				user_id: this.user_id,
				start_date: '',
				end_date: '',
				approved_by: 0,
				location_id: 0,
				building_id: 0,
				assign_to: '',
				status: '',
			},
			tagForm: {
				name: '',
			},
			searchForm: {
				tag: '',
				commenter: '',
			},
			isTag: false,
			isCommenter: false,
			isSearching: false,
			isLoading: false,
			noRecord: false,
			searchBy: '',
			isUpdate: false,
			isAdd: false,
			typeSubmit: false,
			modalTitle: '',
			commentId: '',
		};
	},
	filters: {
		moment: function (date) {
			if (date === null) {
				return '';
			}
			return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
		},
	},
	validations: {
		mentorRoleForm: {
			start_date: {
				requiredIf: requiredIf(function () {
					return this.mentorRoleForm.status != 'draft';
				}),
			},
			location_id: {},
			approved_by: {},
			building_id: {},
			end_date: {},
			assign_to: {},
			status: { required },
		},
	},
	mounted() {
		this.getRoles();
		this.getLocations();
		this.getBuildings();
		this.getApprovers();
	},
	methods: {
		getRoles(page) {
			this.isLoading = true;
			this.noRecord = false;
			if (typeof page === 'undefined') {
				page = 1;
			}
			this.preservePage = page;
			let filter = '&per_page=' + this.pageLimit;
			let userId = '&user_id=' + this.userId;
			axios.get('admin/mentor/roles?pagination=true&page=' + page + filter + userId).then((res) => {
				this.mentorRoles = res.data.response;
				this.isLoading = false;
				if (!this.mentorRoles.length) {
					this.noRecord = true;
					if (page > 1) {
						this.getRoles(page - 1);
					}
				}
			});
		},

		showEditModal(role) {
			this.modalTitle = 'Edit Role';
			this.$bvModal.show('mentorRoleModal');
			this.mentorRoleForm.start_date = role.start_date;
			this.mentorRoleForm.end_date = role.end_date;
			this.mentorRoleForm.approved_by = role.approved_by;
			this.mentorRoleForm.location_id = role.location_id;
			this.mentorRoleForm.building_id = role.building_id;
			this.mentorRoleForm.assign_to = role.assign_to;
			this.mentorRoleForm.status = role.status;
			this.mentorRoleForm.user_id = this.userId;
			this.roleId = role.id;
			this.isUpdate = true;
			this.isAdd = false;
			this.getBuildings();
		},

		showAddModal() {
			this.typeSubmit = false;
			this.modalTitle = 'Add Role';
			this.$bvModal.show('mentorRoleModal');
			this.isAdd = true;
			this.isUpdate = false;
			this.mentorRoleForm = {
				start_date: '',
				end_date: '',
				approved_by: 0,
				location_id: 0,
				building_id: 0,
				assign_to: '',
				status: '',
			};
		},
		getLocations() {
			axios.get('admin/locations').then((res) => {
				res.data.response.forEach((location) => {
					this.locations.push({ value: location.id, text: location.name });
				});
			});
		},
		getBuildings() {
			axios.get('admin/buildings/by_location/' + this.mentorRoleForm.location_id).then((res) => {
				this.buildings = [];
				res.data.response.forEach((building) => {
					this.buildings.push({ value: building.id, text: building.name });
				});
			});
		},
		getApprovers() {
			let filters = '?user_type_id=7';
			axios.get('admin/approvers' + filters).then((res) => {
				res.data.response.forEach((approver) => {
					this.approvers.push({ value: approver.id, text: approver.username });
				});

				this.approvers = this.approvers.sort((a, b) => a.text.localeCompare(b.text));
			});
		},
		updateRole() {
			this.typesubmit = true;
			this.$v.$touch();
			if (!this.$v.mentorRoleForm.$invalid) {
				var token = localStorage.getItem('token');
				var config = {
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
					},
				};
				if (token) {
					axios
						.patch('admin/mentor/roles/' + this.roleId, this.mentorRoleForm, config)
						.then((res) => {
							if (res.status == '200') {
								Swal.fire({
									title: 'Success!',
									text: 'Role updated successfully!',
									icon: 'success',
									width: 350,
									showConfirmButton: false,
									timer: 1500,
								});
								this.getRoles();
								this.typeSubmit = false;
								this.$bvModal.hide('mentorRoleModal');
								this.mentorRoleForm = {
									start_date: '',
									end_date: '',
									approved_by: 0,
									location_id: 0,
									building_id: 0,
									assign_to: '',
									status: '',
								};
							}
						})
						.catch((err) => {
							if (err.response) {
								Swal.fire({
									title: 'Error!',
									text: err.response.data.error.message,
									icon: 'error',
									width: 350,
									showConfirmButton: true,
								});
							}
						});
				}
			}
		},

		deleteRole(roleId) {
			var token = localStorage.getItem('token');
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};
			if (token) {
				Swal.fire({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#34c38f',
					cancelButtonColor: '#f46a6a',
					confirmButtonText: 'Yes, delete it!',
				}).then((result) => {
					if (result.value) {
						axios
							.delete('admin/mentor/roles/' + roleId, config)
							.then((res) => {
								if (res.status == '200') {
									Swal.fire({
										title: 'Deleted!',
										text: 'Role have been deleted!',
										icon: 'success',
										width: 350,
										showConfirmButton: false,
										timer: 1500,
									});
									this.getRoles();
								}
							})
							.catch((err) => {
								if (err.response) {
									Swal.fire({
										title: 'Error!',
										text: err.response.data.error.message,
										icon: 'error',
										width: 350,
										showConfirmButton: true,
									});
								}
							});
					}
				});
			}
		},

		addRole() {
			this.typeSubmit = true;
			this.$v.$touch();
			if (!this.$v.mentorRoleForm.$invalid) {
				var token = localStorage.getItem('token');
				var config = {
					headers: {
						Authorization: 'Bearer ' + token,
						Accept: 'application/json',
					},
				};
				if (token) {
					this.mentorRoleForm.user_id = this.userId;
					axios
						.post('admin/mentor/roles', this.mentorRoleForm, config)
						.then((res) => {
							if (res.status == '200') {
								Swal.fire({
									title: 'Success!',
									text: 'Hours added successfully!',
									icon: 'success',
									width: 350,
									showConfirmButton: false,
									timer: 1500,
								});
								this.$bvModal.hide('mentorRoleModal');
								this.mentorRoleForm = {
									date: '',
									hours: '',
									minutes: '',
									comment: '',
								};
								this.typeSubmit = false;
								this.getRoles();
							}
						})
						.catch(async (err) => {
							if (err.response) {
								await Swal.fire({
									title: 'Error!',
									text: err?.response?.data?.error?.message,
									icon: 'error',
									width: 350,
									showConfirmButton: true,
								});
							}
						});
				}
			}
		},

		searchOption(event) {
			this.searchForm = {
				tag: '',
				commenter: '',
			};
			let selectedValue = event.target.value;
			if (selectedValue == '') {
				this.resetSearch();
			}
			if (selectedValue == 'tag') {
				this.isTag = true;
				this.isCommenter = false;
				this.isSearching = true;
			}
			if (selectedValue == 'commenter') {
				this.isTag = false;
				this.isCommenter = true;
				this.isSearching = true;
			}
		},

		searchComments() {
			this.getComments();
		},

		resetSearch() {
			this.searchForm = {
				tag: '',
				commenter: '',
			};
			this.isSearching = false;
			this.isTag = false;
			this.isCommenter = false;
			this.searchBy = '';
			this.getComments();
		},
	},
};
</script>

<template>
	<div>
		<div class="d-flex">
			<div class="mb-4 mdl-btns ms-auto">
				<!--Add New Comment Modal-->
				<b-button @click="showAddModal" variant="primary">Add Role</b-button>
				<b-modal id="mentorRoleModal" centered :title="modalTitle" title-class="font-18" hide-footer>
					<form>
						<div class="mb-3">
							<div class="row">
								<div class="col-6">
									<label>Select Start Date</label>
									<div>
										<input
											type="date"
											v-model="mentorRoleForm.start_date"
											class="form-control"
											:class="{
												'is-invalid': typeSubmit && $v.mentorRoleForm.start_date.$error,
											}"
										/>
										<div v-if="typeSubmit && $v.mentorRoleForm.start_date.$error" class="invalid-feedback">
											<span v-if="!$v.mentorRoleForm.start_date.required">Start Date is required.</span>
										</div>
									</div>
								</div>

								<div class="col-6">
									<label>Select End Date</label>
									<div>
										<input
											type="date"
											v-model="mentorRoleForm.end_date"
											class="form-control"
											:class="{
												'is-invalid': typeSubmit && $v.mentorRoleForm.end_date.$error,
											}"
										/>
										<div v-if="typeSubmit && $v.mentorRoleForm.end_date.$error" class="invalid-feedback">
											<span v-if="!$v.mentorRoleForm.end_date.required">End Date is required.</span>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="mb-3">
							<div class="row">
								<div class="col-6">
									<label>Select Location</label>
									<div>
										<b-form-select
											class="form-select form-control"
											v-model="mentorRoleForm.location_id"
											:options="locations"
											@change="getBuildings()"
											:class="{
												'is-invalid': typeSubmit && $v.mentorRoleForm.location_id.$error,
											}"
										>
											<option slot="first" :value="null" selected>Select Location</option>
										</b-form-select>

										<div v-if="typeSubmit && $v.mentorRoleForm.location_id.$error" class="invalid-feedback">
											<span v-if="!$v.mentorRoleForm.location_id.required">Location is required.</span>
										</div>
									</div>
								</div>
								<div class="col-6">
									<label>Select Building</label>
									<div>
										<b-form-select
											class="form-select form-control"
											v-model="mentorRoleForm.building_id"
											:options="buildings"
											:class="{
												'is-invalid': typeSubmit && $v.mentorRoleForm.building_id.$error,
											}"
										>
											<option slot="first" :value="null" selected>Select Building</option>
										</b-form-select>

										<div v-if="typeSubmit && $v.mentorRoleForm.building_id.$error" class="invalid-feedback">
											<span v-if="!$v.mentorRoleForm.building_id.required">Building is required.</span>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="mb-3">
							<label>Assign To</label>
							<div>
								<input
									type="text"
									v-model="mentorRoleForm.assign_to"
									class="form-control"
									:class="{
										'is-invalid': typeSubmit && $v.mentorRoleForm.assign_to.$error,
									}"
								/>
								<div v-if="typeSubmit && $v.mentorRoleForm.assign_to.$error" class="invalid-feedback">
									<span v-if="!$v.mentorRoleForm.assign_to.required">Assign to is required.</span>
								</div>
							</div>
						</div>

						<div class="mb-3">
							<label>Approved By</label>

							<div>
								<b-form-select
									class="form-select form-control"
									v-model="mentorRoleForm.approved_by"
									:options="approvers"
									:class="{
										'is-invalid': typeSubmit && $v.mentorRoleForm.approved_by.$error,
									}"
								>
									<option slot="first" :value="null" selected>Select Approver</option>
								</b-form-select>

								<div v-if="typeSubmit && $v.mentorRoleForm.approved_by.$error" class="invalid-feedback">
									<span v-if="!$v.mentorRoleForm.approved_by.required">Approver is required.</span>
								</div>
							</div>
						</div>

						<div class="mb-3">
							<label>Status</label>

							<div>
								<b-form-select
									class="form-select form-control"
									v-model="mentorRoleForm.status"
									:options="status"
									:class="{
										'is-invalid': typeSubmit && $v.mentorRoleForm.status.$error,
									}"
								>
									<option slot="first" :value="null" selected>Select Status</option>
								</b-form-select>

								<div v-if="typeSubmit && $v.mentorRoleForm.status.$error" class="invalid-feedback">
									<span v-if="!$v.mentorRoleForm.status.required">Status is required.</span>
								</div>
							</div>
						</div>

						<div class="mb-0">
							<div>
								<button type="button" v-if="isAdd" @click="addRole" class="btn btn-sm btn-primary">Add Role</button>
								<button type="button" v-if="isUpdate" @click="updateRole" class="btn btn-sm btn-primary">Update Role</button>
							</div>
						</div>
					</form>
				</b-modal>
			</div>
		</div>

		<div class="row mt-3">
			<div class="col-md-12 px-0 cards-cont">
				<div v-if="noRecord">
					<p class="font-size-16 text-center mt-2 mb-0">Record Not Found!</p>
				</div>

				<div class="text-center" v-if="isLoading">
					<b-spinner class="m-2" variant="primary" role="status"></b-spinner>
				</div>

				<b-card class="border border-2 shadow-none" v-for="(role, index) in mentorRoles" :key="index">
					<h5 slot="header" class="mb-0">
						Mentor

						<p class="mb-1 mt-1 float-end icons-wrap me-2">
							<span v-if="role.status == 'active'" class="text-success">Active</span>
							<span v-else-if="role.status == 'completed'" class="text-primary">Completed</span>
							<span v-else-if="role.status == 'client discharged'" class="text-danger">Client Discharged</span>
							<span v-else-if="role.status == 'unpaired'" class="text-danger">Unpaired</span>
							<span v-else-if="role.status == 'draft'" class="text-warning">Draft</span>
						</p>
					</h5>
					<b-card-text>
						<form action="#">
							<div class="d-flex date-info">
								<p class="mb-0">
									<label class="mb-0 me-3 fw-bold">Start Date:</label>
									<label class="mb-0">{{ role.start_date | moment }} <i class="ms-1 bx bx-calendar font-size-20"></i></label>
								</p>

								<p class="mb-0">
									<label class="mb-0 me-3 fw-bold">End Date:</label>
									<label class="mb-0" v-if="role.end_date">{{ role.end_date | moment }} <i class="ms-1 bx bx-calendar font-size-20"></i></label>
									<label class="mb-0" v-if="!role.end_date">Not Selected</label>
								</p>

								<p class="mb-0">
									<label class="mb-0 me-3 fw-bold">Approved By:</label>
									<label class="mb-0">{{ role.approver ? `${role.approver.first_name} ${role.approver.last_name}` : 'N/A' }}</label>
								</p>
							</div>

							<div class="mb-3 row">
								<div class="col-3">
									<label>Location</label>
								</div>
								<div class="col-9">
									<input type="text" class="form-control pe-none bg-secondary bg-soft" placeholder="Location" name="tag" :value="role.location ? role.location : 'N/A'" />
								</div>
							</div>

							<div class="mb-3 row">
								<div class="col-3">
									<label>Mentor Building Assignment</label>
								</div>
								<div class="col-9">
									<input type="text" class="form-control pe-none bg-secondary bg-soft" placeholder="Building" name="tag" :value="role.building ? role.building : 'N/A'" />
								</div>
							</div>

							<div class="mb-3 row">
								<div class="col-3">
									<label>Assigned To</label>
								</div>
								<div class="col-9">
									<input type="text" class="form-control pe-none bg-secondary bg-soft" placeholder="Assignee " name="tag" :value="role.assign_to ? role.assign_to : 'N/A'" />
								</div>
							</div>

							<div class="row mb-3">
								<button type="button" @click="showEditModal(role)" class="btn btn-primary edit_del_btn">Edit</button>
								<button type="button" @click="deleteRole(role.id)" class="btn btn-danger edit_del_btn">Delete</button>
							</div>
						</form>
					</b-card-text>
				</b-card>
			</div>
		</div>
	</div>
</template>
<style scoped>
.edit_del_btn {
	width: 100px;
	margin-left: 12px;
}
.mdl-btns button:nth-child(1) {
	margin-right: 1rem;
}
.icons-wrap {
	position: absolute;
	top: 7px;
	right: 10px;
	display: flex;
}
.icons-wrap a:first-child {
	margin-top: 4px;
}

.app-search input,
.app-search select {
	border-top-right-radius: 0px;
	border-bottom-right-radius: 0px;
}
.app-search .btn-find {
	width: 40%;
	border-top-right-radius: 30px;
	border-bottom-right-radius: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 15px;
	box-shadow: none;
}
.app-search .btn-reset {
	width: 40%;
	font-size: 15px;
	box-shadow: none;
	border-radius: 30px;
}
.date-info {
	margin-bottom: 3rem;
}
.date-info p {
	margin-left: 1rem;
	align-items: baseline;
	display: flex;
	align-items: center;
}
.date-info p:first-child {
	margin-left: 0px;
}
.date-info p label i {
	position: relative;
	top: 0.2rem;
}
</style>
